// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"306":"fafe0a29","428":"87aea40a","447":"31dfbc90","449":"d427096a","574":"fcd332b9","610":"36843fa2","639":"b860ee1f","924":"407b3255"}[chunkId] + ".chunk.js";
};